<template>
  <div class="credential-page">
    <div class="credential-header">
      <TheHeader />
    </div>
    <div class="credential-container">
      <div class="credential-back">
        <router-link to="/dashboard/casts" class="back-link">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Back to My Casts
        </router-link>
      </div>

      <div v-if="loading" class="credential-loading">
        <div class="loading-spinner"></div>
        <p>Loading cast information...</p>
      </div>

      <div v-else-if="error" class="credential-error">
        <h3>Error</h3>
        <p>{{ error }}</p>
        <router-link to="/dashboard/casts" class="error-link">Go to My Casts</router-link>
      </div>

      <div v-else class="credential-content">
        <div class="cast-info">
          <h2>{{ castInfo.event_name }}</h2>
          <p class="cast-id">Cast ID: {{ roomId }}</p>
        </div>
        <CredentialManagement :roomId="roomId" />
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script>
import TheHeader from '@/layouts/components/navbar/NavbarHorizontal2.vue';
import TheFooter from '@/layouts/components/footer/TheFooter.vue';
import CredentialManagement from '@/components/credentials/CredentialManagement.vue';

export default {
  name: 'CredentialManagementPage',
  components: {
    TheHeader,
    TheFooter,
    CredentialManagement,
  },
  data() {
    return {
      roomId: this.$route.params.castId,
      loading: true,
      error: null,
      castInfo: {},
    };
  },
  mounted() {
    this.loadCastInfo();
  },
  methods: {
    async loadCastInfo() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('cast/editEvent', this.roomId);
        this.castInfo = response.data.details;
        this.loading = false;
      } catch (err) {
        console.error('Failed to load cast info:', err);
        this.error = 'Failed to load cast information. Please try again.';
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.credential-page {
  min-height: 100vh;
  background: #0a0a0a;
}

.credential-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding-bottom: 20px;
}

.credential-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

.credential-back {
  margin-bottom: 24px;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #a6a6a8;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.back-link:hover {
  color: #d7df23;
}

.credential-loading,
.credential-error {
  background: #1f272f;
  border-radius: 12px;
  padding: 60px 40px;
  text-align: center;
  color: #a6a6a8;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #31394e;
  border-top-color: #d7df23;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.credential-error h3 {
  color: #ef4444;
  margin-bottom: 12px;
}

.error-link {
  display: inline-block;
  margin-top: 20px;
  padding: 10px 20px;
  background: #d7df23;
  color: #181a20;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
}

.credential-content {
  background: #1f272f;
  border-radius: 12px;
  overflow: hidden;
}

.cast-info {
  padding: 24px;
  border-bottom: 1px solid #31394e;
}

.cast-info h2 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
}

.cast-id {
  margin: 0;
  font-size: 13px;
  color: #647181;
  font-family: monospace;
}
</style>
